import React, { useEffect, useState } from "react";
import LocationSelector from "./components/LocationSelector/LocationSelector"; // Import the LocationSelector component
import styles from "./LocationModal.module.css"; // Create a CSS module for styling
import { lockBodyScroll, unlockBodyScroll } from "../../utils/scrollUtils";

import TopHeader from "./components/TopHeader/TopHeader";
import LocationMessage from "./components/LocationMessage/LocationMessage";

interface LocationModalProps {
  isOpen: boolean;
  onClose: () => void;
  initialLocation?: {
    // Add optional initial location prop
    name?: string;
    lastname?: string;
    country?: string;
    department?: string;
    province?: string;
    district?: string;
    address?: string;
    phoneNumber?: string;
    // New zone arrays for array-based delivery zones
    deliveryFeeZones?: { documentId: string; name: string }[];
    deliveryLeadTimeZones?: { documentId: string; name: string }[];
    // Legacy compatibility
    deliveryFeeZone?: { documentId: string; name: string } | null;
  };
}

const LocationModal: React.FC<LocationModalProps> = ({
  isOpen,
  onClose,
  initialLocation,
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      lockBodyScroll();
      requestAnimationFrame(() => {
        setIsVisible(true);
      });
    } else {
      setIsVisible(false);
      setTimeout(() => {
        unlockBodyScroll();
      }, 300);
    }

    // Cleanup function to ensure scroll is restored if component unmounts
    return () => {
      unlockBodyScroll();
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    // Wait for animation to complete before calling onClose
    setTimeout(() => {
      onClose();
    }, 300);
  };

  if (!isOpen) return null;

  return (
    <div
      className={`${styles.modalOverlay} ${isVisible ? styles.visible : ""}`}
      onClick={handleClose}
    >
      <div
        className={`${styles.modalContent} ${isVisible ? styles.visible : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <TopHeader onClose={handleClose} />
        <LocationMessage />
        <LocationSelector
          onClose={handleClose}
          initialLocation={initialLocation} // Pass the initialLocation to LocationSelector
        />
      </div>
    </div>
  );
};

export default LocationModal;
